import React, { useState, useEffect } from "react";
import { MenuItem, Select, InputLabel, FormControl, SelectChangeEvent } from "@mui/material";

interface SelectDropdownProps {
  label: string;
  value: any; 
  filterKey: string;
  options: { key: number | string; value: string }[]; //  Now options are passed as a prop
  onChange: (selected: string) => void;
  isError?: boolean; 
  isDisabled?: boolean; 
  
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({  label, filterKey, options, onChange , isError = false, value, isDisabled= false  }) => {
  const [selectedValue, setSelectedValue] = useState<string>(value || "");
  useEffect(() => {
    if (!options) return;
    if (!options.some((option) => option?.key != null && option.key.toString() === selectedValue)) {
      setSelectedValue(""); 
    }
  }, [options, selectedValue]);

  // Update selectedValue when the value prop changes
  useEffect(() => {
    setSelectedValue(value || "");
  }, [value]);

  const handleChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value;
    setSelectedValue(value);
    onChange(value);
  };
  return (
    <FormControl  sx={{ minWidth: 120 }}>
        <InputLabel shrink>{label}</InputLabel> {/*  Added 'shrink' to fix overlap */}
        <Select
            disabled ={isDisabled}
            value={selectedValue}
            onChange={handleChange}
            displayEmpty
            renderValue={selected => {
              // Show blank in the select box if nothing is selected
              if (!selected) return <span>&nbsp;</span>;
              const selectedOption = options.find(option => option.key.toString() === selected);
              return selectedOption ? selectedOption.value : "";
            }}
            sx={{
                borderRadius: "8px",
                fontSize: "14px",
                background: "white",
                color: isError ? "red" : "rgb(196 196 196)", //  Text color changes if there's an error
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: isError ? "red" : "rgb(196 196 196)", //  Border color changes based on error state
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: isError ? "red" : "black", //  Darker red on hover if error
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: isError ? "red" : "blue", //  Keep red border on focus if error
                },
              }}
        >
            <MenuItem key={''} value={''}>
            <em style={{ color: "#aaa" }}>Clear Selection</em>
          </MenuItem>
            {options && options.length > 0 ? (
            options.map((option) => (
              <MenuItem key={option.key} value={option?.key?.toString() || ''}>
                {option.value} 
              </MenuItem>
            ))
            ) : (
            <MenuItem disabled>No options available</MenuItem>
            )}
        </Select>
    </FormControl>

  );
};

export default SelectDropdown;




//////////   <<<<<<<<<<<<<<<<<<<<<<<<< SINGLE SELECT SEARCHABKE  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> /////////

// import React, { useState, useEffect } from "react";
// import {
//   Autocomplete,
//   TextField,
//   InputLabel,
//   FormControl,
//   MenuItem,
// } from "@mui/material";

// interface SelectDropdownProps {
//   label: string;
//   value: any;
//   filterKey: string;
//   options: { key: number | string; value: string }[];
//   onChange: (selected: string) => void;
//   isError?: boolean;
//   isDisabled?: boolean;
// }

// const SelectDropdown: React.FC<SelectDropdownProps> = ({
//   label,
//   filterKey,
//   options,
//   onChange,
//   isError = false,
//   value,
//   isDisabled = false,
// }) => {
//   const [selectedValue, setSelectedValue] = useState<string>(value || "");
//   const [inputValue, setInputValue] = useState("");

//   useEffect(() => {
//     if (!options) return;
//     if (!options.some((option) => option?.key?.toString() === selectedValue)) {
//       setSelectedValue(""); 
//     }
//   }, [options, selectedValue]);

//   useEffect(() => {
//     setSelectedValue(value || "");
//   }, [value]);

//   const handleChange = (event: React.SyntheticEvent, newValue: { key: string | number; value: string } | null) => {
//     const value = newValue?.key.toString() || "";
//     setSelectedValue(value);
//     onChange(value);
//   };

//   const handleInputChange = (event: React.SyntheticEvent, newInputValue: string) => {
//     setInputValue(newInputValue);
//   };

//   return (
//     <FormControl sx={{ minWidth: 120 }} fullWidth>
//       <InputLabel shrink>{label}</InputLabel>
//       <Autocomplete
//         disabled={isDisabled}
//         options={options || []}
//         getOptionLabel={(option) => option.value}
//         value={options.find((option) => option.key.toString() === selectedValue) || null}
//         onChange={handleChange}
//         inputValue={inputValue}
//         onInputChange={handleInputChange}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             variant="outlined"
//             sx={{
//               borderRadius: "8px",
//               fontSize: "14px",
//               background: "white",
//               color: isError ? "red" : "rgb(196 196 196)",
//               "& .MuiOutlinedInput-notchedOutline": {
//                 borderColor: isError ? "red" : "rgb(196 196 196)",
//               },
//               "&:hover .MuiOutlinedInput-notchedOutline": {
//                 borderColor: isError ? "red" : "black",
//               },
//               "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                 borderColor: isError ? "red" : "blue",
//               },
//             }}
//           />
//         )}
//         renderOption={(props, option) => (
//           <MenuItem {...props} key={option.key}>
//             {option.value}
//           </MenuItem>
//         )}
//         isOptionEqualToValue={(option, value) => option.key === value.key}
//         noOptionsText="No options available"
//       />
//     </FormControl>
//   );
// };

// export default SelectDropdown;


//////////////////////////////<<<<<<<<<<<<<<<<<<<<<<<< END >>>>>>>>>>>>>>>>>>>>>>>>>>>>>////////////////////////////////////////













/////////////////////// <<<<<<<<<<<<<<<<<<<<<<<<<<< MULTI SELECT SEARCHABLE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>////////////

// import React, { useState, useEffect } from "react";
// import {
//   Autocomplete,
//   TextField,
//   InputLabel,
//   FormControl,
//   MenuItem,
//   Chip,
// } from "@mui/material";

// interface SelectDropdownProps {
//   label: string;
//   value: any;
//   filterKey: string;
//   options: { key: number | string; value: string }[];
//   onChange: (selected: string[]) => void;
//   isError?: boolean;
//   isDisabled?: boolean;
// }

// const SelectDropdown: React.FC<SelectDropdownProps> = ({
//   label,
//   filterKey,
//   options,
//   onChange,
//   isError = false,
//   value,
//   isDisabled = false,
// }) => {
//   const [selectedValues, setSelectedValues] = useState<string[]>(Array.isArray(value) ? value : []);
//   const [inputValue, setInputValue] = useState("");

//   useEffect(() => {
//     if (!options) return;
//     // Filter out any selected values that don't exist in current options
//     const validValues = selectedValues.filter(val => 
//       options.some(option => option?.key?.toString() === val)
//     );
//     if (validValues.length !== selectedValues.length) {
//       setSelectedValues(validValues);
//     }
//   }, [options, selectedValues]);

//   useEffect(() => {
//     setSelectedValues(Array.isArray(value) ? value : []);
//   }, [value]);

//   const handleChange = (
//     event: React.SyntheticEvent,
//     newValues: { key: string | number; value: string }[]
//   ) => {
//     const values = newValues.map(item => item.key.toString());
//     setSelectedValues(values);
//     onChange(values);
//   };

//   const handleInputChange = (event: React.SyntheticEvent, newInputValue: string) => {
//     setInputValue(newInputValue);
//   };

//   return (
//     <FormControl sx={{ minWidth: 120 }} fullWidth>
//       <InputLabel shrink>{label}</InputLabel>
//       <Autocomplete
//         multiple
//         disabled={isDisabled}
//         options={options || []}
//         getOptionLabel={(option) => option.value}
//         value={options.filter(option => selectedValues.includes(option.key.toString()))}
//         onChange={handleChange}
//         inputValue={inputValue}
//         onInputChange={handleInputChange}
//         renderInput={(params) => (
//           <TextField
//             {...params}
//             variant="outlined"
//             sx={{
//               borderRadius: "8px",
//               fontSize: "14px",
//               background: "white",
//               color: isError ? "red" : "rgb(196 196 196)",
//               "& .MuiOutlinedInput-notchedOutline": {
//                 borderColor: isError ? "red" : "rgb(196 196 196)",
//               },
//               "&:hover .MuiOutlinedInput-notchedOutline": {
//                 borderColor: isError ? "red" : "black",
//               },
//               "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//                 borderColor: isError ? "red" : "blue",
//               },
//             }}
//           />
//         )}
//         renderOption={(props, option) => (
//           <MenuItem {...props} key={option.key}>
//             {option.value}
//           </MenuItem>
//         )}
//         renderTags={(value, getTagProps) =>
//           value.map((option, index) => (
//             <Chip
//                 // @ts-ignore
//               key={option.key}
//               label={option.value}
//               {...getTagProps({ index })}
//             />
//           ))
//         }
//         isOptionEqualToValue={(option, value) => option.key === value.key}
//         noOptionsText="No options available"
//       />
//     </FormControl>
//   );
// };

// export default SelectDropdown;


///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////